// 包装一些 JS 内建函数

export const safeDecodeURI = (uri: string) => {
  try {
    return decodeURI(uri);
  } catch (error) {
    return uri;
  }
};

export const safeDecodeURIComponent = (uri: string) => {
  try {
    return decodeURIComponent(uri);
  } catch (error) {
    return uri;
  }
};
